import useViewport from '../functions/viewport'

import DesktopComponent from './DesktopComponent/DesktopComponent'
import MobileComponent from './MobileComponent/MobileComponent'

const HomePage = () => {
  const { width } = useViewport()

  return width < 500 ? <MobileComponent /> : <DesktopComponent />
}

export default HomePage
